export const fiDvmMdfyActTypes = {
  add: 'fiDvmMdfyActTypes_Add',
  edit: 'fiDvmMdfyActTypes_Edit',
  view: 'fiDvmMdfyActTypes_View',
  clone: 'fiDvmMdfyActTypes_Clone',
  import: 'fiDvmMdfyActTypes_Import',
  del: 'fiDvmMdfyActTypes_Delete',
  reset: 'fiDvmMdfyActTypes_Reset',
  schedule: 'fiDvmMdfyActTypes_Schedule',
};
